import { round } from "./round";

export function formatPercentage(percentage: number, decimals: number = 0) {
  return `${round(percentage * 100, decimals).toFixed(decimals)}%`;
}
